<template>
  <div>
    <bread-crumb :navigationArray="navigationLink"/>
    <div class="white-container">
      <h5>Сообщить о проблеме в медицине</h5>
      <div class="tabs"></div>
      <section class="content" v-if="content">
        <div class="block_info">
          <h5>МЕДЧАТЫ</h5>
          <div v-if="content?.first_block" class="ckEditor-html ckEditor-medical" v-html="content?.first_block"></div>
          <div v-if="content?.second_block" class="ckEditor-html ckEditor-medical" v-html="content?.second_block"></div>
        </div>
      </section>
      <div style="margin-top: 24px;">
        <medical-accordion v-for="(chat, idx) in content?.chats" :key="`chat-${idx}`" :content="chat"/>
      </div>
    </div>
  </div>
</template>
<script>
import BreadCrumb from '@/components/BreadCrumb'
import MedicalAccordion from '@/components/forms/MedicalAccordion'

export default {
  name: 'ReportMedicalProblem',
  components: {
    BreadCrumb,
    MedicalAccordion
  },
  data () {
    return {
      leader: null,
      content: null
    }
  },
  computed: {
    navigationLink () {
      return [
        {
          title: this.$store.getters.GET_LANG ? 'Главная' : 'Home',
          path: '/'
        },
        {
          title: 'Сообщить о проблеме в медицине'
        }
      ]
    }
  },
  methods: {
    fetchContent () {
      fetch(`${this.$store.getters.getUrlApi}api/page/special/medical`, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      }).then(res => res.json()).then(result => {
        this.content = result?.content
      })
    }
  },
  mounted () {
    document.title = 'Сообщить о проблеме в медицине'
    this.fetchContent()
  }
}
</script>
<style lang="scss" scoped>
.ckEditor-medical {
  width: 100%;
}
.white-container {
  width: 90.25rem;
  margin: 0 auto;
  padding: 2.5rem 2.94rem;

  h5 {
    font-weight: 600;
    font-size: 1.38rem;
    line-height: 1.75rem;
    margin-bottom: 24px;
    color: #1F3245;
  }

  .tabs {
    display: flex;
    border-radius: .125rem;
    border-bottom: .06rem solid #D5D6D9;
    margin: 2rem 0;

    p {
      font-size: .75rem;
      line-height: 1.125rem;
      color: #003E78;
      opacity: 0.6;
      margin-right: 1.25rem;
      padding-bottom: 1.375rem;
      cursor: pointer;
      transition: font-size .2s;
    }

    .active {
      font-weight: 600;
      font-size: .813rem;
      line-height: 1.25rem;
      color: #246CB7;
      border-bottom: .125rem solid #246CB7;
      padding-bottom: 1.25rem;
      margin-bottom: -0.07rem;
      margin-top: -0.15rem;
      transition: font-size .2s;
    }
  }
}

section {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.block_info {
  display: flex;
  flex-direction: column;
  width: 100%;
}

img {
  width: 12.13rem;
}

.img_content {
  width: 12.145rem;
  height: 15.0625rem;
  margin-right: 1.88rem;
  border-radius: .5rem;
}

.content {
  .ckEditor-html {
    ::v-deep {
      * {
        margin: revert;
        padding: revert;
        list-style-type: revert;
        font-size: revert;
        font-weight: revert;
      }
    }
  }

  h5 {
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 1.5rem;
    color: rgba(23, 23, 23, 0.8);
  }

  .title-content {
    margin-top: 1.25rem;
    margin-bottom: .5rem;
    font-weight: 600;
    font-size: .88rem;
    line-height: 1.38rem;
    color: #1F3245;
  }

  a {
    font-size: .88rem;
    line-height: 1.38rem;
    color: #246CB7;
  }

  .text-content {
    font-size: .88rem;
    line-height: 1.38rem;
    color: rgba(23, 23, 23, 0.8);
    margin-bottom: 1.25rem;
  }

  .button-link {
    width: fit-content;
    font-weight: bold;
    font-size: .88rem;
    line-height: 1.25rem;
    color: #FFFFFF;
    background: #246CB7;
    border-radius: .19rem;
    padding: .5rem 2.125rem .44rem 2.125rem;
  }

  .date-content {
    margin-top: .75rem;
    font-size: .87rem;
    line-height: 1.375rem;
    color: #5E686C;
  }
}

@media screen and (max-width: 768px) {
  .img_content {
    width: 10.79rem;
    height: 12.59rem;
    margin-right: 1.24rem;
  }

  .white-container {
    width: auto;
    margin: 0 .75rem;
    padding: 1.86rem 1.25rem;
  }
}

@media screen and (max-width: 420px) {

  .white-container {
    width: 100%;
    margin: 0;
    padding: 1.88rem 1rem;
  }

  section {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }
  .img_content {
    width: 8.8rem;
    height: 10.82rem;
    margin-bottom: 1.4rem;
  }
  .date-content {
    margin-top: .5rem;
  }
  .block_info {
    width: 100%;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .button-link {
    width: 15rem;
  }
}

</style>
